import { Injectable } from '@angular/core';

export type SiteLanguage = 'fr' | 'en';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly storageKey = 'cecile-language';
  language: SiteLanguage = window.location.pathname.startsWith('/en') ? 'en' : 'fr';

  constructor() {
    document.documentElement.lang = this.language;
  }

  get isEnglish(): boolean {
    return this.language === 'en';
  }

  setLanguage(language: SiteLanguage): void {
    this.language = language;
    document.documentElement.lang = language;
  }

  chooseLanguage(language: SiteLanguage): void {
    localStorage.setItem(this.storageKey, language);
    this.setLanguage(language);
  }

  path(page: 'works' | 'biography' | 'press' | 'contact', language = this.language): string {
    const frenchPaths = { works: '/works', biography: '/biographie', press: '/press', contact: '/contact' };
    const englishPaths = { works: '/en/works', biography: '/en/biography', press: '/en/press', contact: '/en/contact' };
    return (language === 'en' ? englishPaths : frenchPaths)[page];
  }

  counterpart(url: string): string {
    const cleanUrl = url.split('?')[0].split('#')[0];
    const pairs: Record<string, string> = {
      '/works': '/en/works',
      '/biographie': '/en/biography',
      '/press': '/en/press',
      '/contact': '/en/contact',
      '/en/works': '/works',
      '/en/biography': '/biographie',
      '/en/press': '/press',
      '/en/contact': '/contact',
    };
    return pairs[cleanUrl] ?? (this.isEnglish ? '/works' : '/en/works');
  }
}
